// Shared helpers for the stock-plan admin screens.

export const STOCK_PLAN_STATUS = {
  draft: { label: 'Brouillon', color: 'grey' },
  importing: { label: 'Import en cours', color: 'primary' },
  ready: { label: 'Prêt', color: 'success' },
  failed: { label: 'Échec', color: 'error' },
}

export const SCOPE_CHOICES = [
  { text: 'Organisation', value: 'organisation' },
  { text: 'Équipe', value: 'team' },
  { text: 'Utilisateur', value: 'user' },
]

// First human-readable message from an apiClient error (DRF field errors included).
export function apiErrorMessage(err) {
  const data = (err && err.data) || {}
  if (data.error || data.detail) return data.error || data.detail
  for (const value of Object.values(data)) {
    if (Array.isArray(value) && value.length) return String(value[0])
    if (typeof value === 'string') return value
  }
  return (err && err.message) || 'Erreur inattendue.'
}
